// @todo replace by enum? https://redux.js.org/recipes/usage-with-typescript
export const LOGIN_REQUESTED = 'LOGIN_REQUESTED'
export const LOGIN_DONE = 'LOGIN_DONE'
export const LOGIN_FAILED = 'LOGIN_FAILED'